var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table table-sm table-hover table-bordered"},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }